// extracted by mini-css-extract-plugin
module.exports = {"registration":"Registration_registration__3SpJe"};